import { render, staticRenderFns } from "./DialogLoading.vue?vue&type=template&id=53e41658"
import script from "./DialogLoading.vue?vue&type=script&lang=js"
export * from "./DialogLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e41658')) {
      api.createRecord('53e41658', component.options)
    } else {
      api.reload('53e41658', component.options)
    }
    module.hot.accept("./DialogLoading.vue?vue&type=template&id=53e41658", function () {
      api.rerender('53e41658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogLoading.vue"
export default component.exports